import React from 'react';

import { Button } from '@infoods/lifebase-ui';

import classes from './AlreadySubscribedResult.module.scss';
import { PaymentResultsInbodyBlock } from '../../../../../inbody';

type AlreadySubscribedResultProps = {
  entityId: number | null;
  retryPath: string;
};

const AlreadySubscribedResult = ({
  entityId,
  retryPath,
}: AlreadySubscribedResultProps) => (
  <div className={classes.container}>
    {entityId && (
      <PaymentResultsInbodyBlock title="Complete Your InBody Scan" entityId={entityId} />
    )}
    <Button variant="outlined" href={`#!${retryPath}`}>
      Finish
    </Button>
  </div>
);

export { AlreadySubscribedResult };
